export default __webpack_public_path__ + "static/media/icon-outpatient.ca7ee656.svg";